/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Limit_3_TermInputs */

const en_svc_rag_limit_3_term = /** @type {(inputs: Svc_Rag_Limit_3_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No stale answers`)
};

const lv_svc_rag_limit_3_term = /** @type {(inputs: Svc_Rag_Limit_3_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nekādu novecojušu atbilžu`)
};

/**
* | output |
* | --- |
* | "No stale answers" |
*
* @param {Svc_Rag_Limit_3_TermInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_limit_3_term = /** @type {((inputs?: Svc_Rag_Limit_3_TermInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Limit_3_TermInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_limit_3_term(inputs)
	return en_svc_rag_limit_3_term(inputs)
});